import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 48 48"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M43 5.5A1.5 1.5 0 0 0 41.5 4h-35A1.5 1.5 0 0 0 5 5.5v37A1.5 1.5 0 0 0 6.5 44h35a1.5 1.5 0 0 0 1.5-1.5zm-35 9h13v5a1.5 1.5 0 0 0 1.5 1.5H30v20H8zm25 5a1.5 1.5 0 0 0-1.5-1.5H24v-5a1.5 1.5 0 0 0-1.5-1.5H8V7h32v34h-7z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }